export default{

  methods:{
    access_portal(){
      this.$router.push('/trustee_view_dashboard')
    }
  }
}